import { ReactNode, useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AuthContext } from '@/context/auth-context'
import FullPageLoader from '@/components/loaders/FullPageLoader'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { signInPathFor } from '@/auth/utils/auth-redirect'

/**
 * Dashboard Sign In Gate
 * With `ONBOARDING_REFRESH_AUTH_PAGES` on, every dashboard page needs a permanent account, so
 * anonymous users are sent to `/sign-in` before the dashboard layout draws its sidebar.
 * With the flag off, the page guards inside the layout decide.
 */
export default function DashboardSignInGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const user = useContext(AuthContext)?.user

  if (!kGetFeatureFlagStatus(kFeatureFlags.ONBOARDING_REFRESH_AUTH_PAGES)) return children

  // Before the anonymous session exists, a redirect would also bounce users who are signed in.
  if (user == null) return <FullPageLoader />
  if (user.isAnonymous) return <Navigate to={signInPathFor(location)} replace />

  return children
}
